import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/esg/esgEight/img1.webp";

function EsgEight() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div id="esgEight" className={`esgEight ${isVisible ? "visible" : ""}`}>
        <div className="esgEightTitle">
          <h1 className={` ${isVisible ? "visible" : ""}`}>
            {t("esg_eight_title")}
          </h1>
          <p className={` ${isVisible ? "visible" : ""}`}>
            {t("esg_eight_text")}
          </p>
        </div>
        <div className="cards">
          <div className={`card1 card ${isVisible ? "visible" : ""}`}>
            <img src={img1} alt="" width={"250px"} />
            <div className="text">
              <h3>tCO₂e/km</h3>
              <p>0,001259</p>
              <h5>2023</h5>
            </div>
          </div>
          <div className={`card2 card ${isVisible ? "visible" : ""}`}>
            <img src={img1} alt="" width={"250px"} />
            <div className="text">
              <h3>tCO₂e/km</h3>
              <p>0,001049 </p>
              <h5>2024</h5>
            </div>
          </div>
          <div className={`card3 card ${isVisible ? "visible" : ""}`}>
            <img src={img1} alt="" width={"250px"} />
            <div className="text">
              <h3>tCO₂e/km</h3>
              <p>0,001052</p>
              <h5>2025</h5>
            </div>
          </div>
          {/* <div className={`card4 card ${isVisible ? "visible" : ""}`}>
            <img src={img1} alt="" width={"250px"} />
            <div className="text">
              <h3>Lorem ipsum</h3>
              <p>10</p>
            </div>
          </div> */}
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default EsgEight;
